import React from 'react'
import {GROUP_LABELS, GROUP_ORDER, PRESETS, STAGES, UNASSIGNED_OBJ} from '../constants'
import {countDays, fmAsOf, fmDate, fmN, fmP} from '../helpers/format'

// Thanh lọc kiểu antd theo bản mẫu; không hiện ở tab Report
const FilterBar = ({tab, filters, maxDate, onPreset, onChange, data}) => {
    const dims = data && data.tab === tab.key ? data.filters.options.dims : []
    const summary = data && data.tab === tab.key ? data.summary : null
    const asOf = data ? fmAsOf(data.as_of) : null

    return (
        <div className="bar">
            <div className="fgrid">
                <div className="fld">
                    <label>Khoảng thời gian</label>
                    <div className="ctl">
                        <div className="seg">
                            {PRESETS.map(preset => (
                                <button key={preset.value} type="button" aria-pressed={filters.preset === preset.value} onClick={() => onPreset(preset.value)}>
                                    {preset.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="fld">
                    <label>Từ ngày</label>
                    <input type="date" value={filters.from} max={maxDate} onChange={e => e.target.value && onChange({from: e.target.value, preset: 'cus'})}/>
                </div>
                <div className="fld">
                    <label>Đến ngày</label>
                    <input type="date" value={filters.to} max={maxDate} onChange={e => e.target.value && onChange({to: e.target.value, preset: 'cus'})}/>
                </div>
                {tab.key === 'process' && (
                    <div className="fld">
                        <label>Công đoạn</label>
                        <select value={filters.stage} onChange={e => onChange({stage: e.target.value})}>
                            {STAGES.map(stage => <option key={stage.value} value={stage.value}>{stage.label}</option>)}
                        </select>
                    </div>
                )}
                {tab.key === 'process' ? (
                    <div className="fld">
                        <label>{tab.unit}</label>
                        <select value={filters.obj} onChange={e => onChange({obj: e.target.value})}>
                            <option value="">Tất cả {tab.unit.toLowerCase()}</option>
                            {GROUP_ORDER.map(group => <option key={group} value={group}>{GROUP_LABELS[group]}</option>)}
                        </select>
                    </div>
                ) : !!dims.length && (
                    <div className="fld">
                        <label>{tab.unit}</label>
                        <select value={filters.obj} onChange={e => onChange({obj: e.target.value})}>
                            <option value="">Tất cả {tab.unit.toLowerCase()}</option>
                            {dims.map(dim => <option key={`${dim.dim_type}|${dim.id}`} value={dim.id || UNASSIGNED_OBJ}>{dim.name || dim.id}</option>)}
                        </select>
                    </div>
                )}
            </div>
            <div className="sumline">
                <span>Khoảng: <b>{fmDate(filters.from)} – {fmDate(filters.to)}</b> ({countDays(filters.from, filters.to)} ngày)</span>
                <span>Số lỗi: <b className="mono">{fmN(summary && summary.hits)}</b></span>
                <span>Sản phẩm lỗi: <b className="mono">{fmN(summary && summary.items)}</b></span>
                <span>
                    Sản lượng: <b className="mono">{fmN(summary && summary.output)}</b>
                    {summary && summary.output !== null && <span style={{color: 'var(--ink-3)'}}> (theo {data.output_basis})</span>}
                </span>
                <span>Tỉ lệ lỗi: <b className="mono">{summary ? fmP(summary.rate) : '—'}</b></span>
                <span>Số liệu tính đến: <b>{asOf || 'chưa có lần chạy'}</b></span>
            </div>
        </div>
    )
}

export default FilterBar
